import axios from 'axios';
import { API_CONFIG } from '../config/apiConfig';

/**
 * Public API client for unauthenticated endpoints
 * Used for token-based customer flows (order, status)
 */
const publicApiClient = axios.create({
    baseURL: API_CONFIG.baseUrl,
});

// Request interceptor for logging
publicApiClient.interceptors.request.use(
    (config) => {
        console.log(`[Public API Request] ${config.method?.toUpperCase()} ${config.url}`);
        return config;
    },
    (error) => {
        console.error('[Public API Request] Interceptor error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
publicApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('[Public API Response] Error:', error.response?.status, error.response?.data);
        return Promise.reject(error);
    }
);

export default publicApiClient;
